import { MutationTree } from 'vuex'
import { PageResult } from '@/api/types'
import { Project } from '@/api/model/project'
import { ProjectsState } from '@/store/projects'

export const mutations: MutationTree<ProjectsState> = {
    fetchData(state: ProjectsState): void {
        state.loading = true
        state.totalItems = null
        state.error = null
    },

    fetchDataSuccess(state: ProjectsState, result: PageResult<Project>): void {
        state.loading = false
        state.error = null
        state.projects = result.collection
        state.totalItems = result.totalItems
        state.totalPages = result.totalPages
    },

    fetchDataFailure(state: ProjectsState, error: string): void {
        state.loading = false
        state.error = error
    },

    setPage(state: ProjectsState, payload: { page: number }): void {
        state.page = payload.page
    },

    applyOrder(state: ProjectsState, payload: { field: string, direction: string }): void {
        state.orderField = payload.field
        state.orderDirection = payload.direction
    },

    applyActiveFilter(state: ProjectsState, payload: { activeFilter: number[] }): void {
        state.activeFilter = payload.activeFilter
    },

    applyCompanyFilter(state: ProjectsState, payload: { query: string }): void {
        state.companyFilter = payload.query
    },

    applyNameFilter(state: ProjectsState, payload: { query: string }): void {
        state.nameFilter = payload.query
    },

    resetFilters(state: ProjectsState): void {
        state.activeFilter = null
        state.companyFilter = null
        state.nameFilter = null
    },
}
